import { IErrorResponseType } from "../../constants/commonTypes";
import * as PaymentActions from "../actionTypes/paymentSummaryActionTypes";
import { IAccountBalanceResponse, IPaymentSummaryResponse } from "../reducers/paymentSummaryReducer";


// Get Account Balance
export function getAccountBalance(): PaymentActions.GetAccountBalanceAction {
  return {
    type: PaymentActions.GET_ACCOUNT_BALANCE
  };
}

export function getAccountBalanceRequest(): PaymentActions.GetAccountBalanceRequestAction {
  return {
    type: PaymentActions.GET_ACCOUNT_BALANCE_REQUEST
  }
}

export function getAccountBalanceSuccess(response: IAccountBalanceResponse): PaymentActions.GetAccountBalanceSuccessAction {
  return {
    type: PaymentActions.GET_ACCOUNT_BALANCE_SUCCESS,
    accountCurrency: response.currency,
    accBalance: response.accBalance,
    accountNo: response.accountNo,
    isAccountDetailsFetched: response.isAccountDetailsFetched,
  }
}

export function getAccountBalanceFailure(error: Error | string | IErrorResponseType): PaymentActions.GetAccountBalanceFailureAction {
  return {
    type: PaymentActions.GET_ACCOUNT_BALANCE_FAILURE,
    error
  }
}



// Get Payment Summary
export function getPaymentSummary(): PaymentActions.GetPaymentSummaryAction {
  return {
    type: PaymentActions.GET_PAYMENT_DETAILS
  };
}

export function getPaymentSummaryRequest(): PaymentActions.GetPaymentSummaryRequestAction {
  return {
    type: PaymentActions.GET_PAYMENT_DETAILS_REQUEST
  }
}

export function getPaymentSummarySuccess(response: IPaymentSummaryResponse): PaymentActions.GetPaymentSummarySuccessAction {
  return {
    type: PaymentActions.GET_PAYMENT_DETAILS_SUCCESS,
    amount: response.amount,
    inrAmt: response.inrAmt,
    bankCharges: response.bankCharges,
    sourceTax: response.sourceTax,
    gst: response.gst,
    totalAmt: response.totalAmt,
    rate: response.rate,
    originalRate:response.originalRate,
    currency: response.currency,
    fccTax: response.fccTax,
    commissionAmount: response.commissionAmount,
    isPaymentDetailsFetched: response.isPaymentDetailsFetched,
  }
}

export function getPaymentSummaryFailure(error: Error | string | IErrorResponseType): PaymentActions.GetPaymentSummaryFailureAction {
  return {
    type: PaymentActions.GET_PAYMENT_DETAILS_FAILURE,
    error
  }
}


export function getTransactionSummaryConsentReset(): PaymentActions.GetTransactionSummaryResetAction {
  return {
    type: PaymentActions.GET_TRANSACTION_SUMMARY_RESET,
  }
}